$(document).ready(function(){
    'use strict'

    //Прокрутка элеметнов в блоке с горизонтальным скролом.
    const scrollTabsEl = $('.scroll-tabs__el');

    scrollTabsEl.each(function () {
        $(this).attr('data-scroll-offset', $(this).offset().left)
    })

    scrollTabsEl.on('click', function () {
        const scrollTabsBlock = $(this).parents('.scroll-tabs');
        const scrollTabsHalf = scrollTabsBlock.width() / 2
        const scrollTabsElHalf = $(this).width() / 2
        const leftPadding = 20

        scrollTabsBlock.stop().animate({
            scrollLeft: $(this).attr('data-scroll-offset') - leftPadding - scrollTabsHalf + scrollTabsElHalf
        });
    })
});
